import { axiosInstance } from "@/lib/api/client";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@/lib/constants/mimeTypes";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { Company } from "@rumble-it/common-lib/types/models/Company.interface";

export const getDealershipCompanies = async () =>
  axiosInstance
    .get<CollectionResponse<Company>>("/companies", {
      params: { pagination: false, type: "dealership" },
    })
    .then((response) => response.data);

export const getCurrentUser = async () =>
  axiosInstance.get("/current-user/me").then((response) => response.data);

export const dealershipSwitch = async (dealershipIri: string) =>
  axiosInstance
    .patch(
      "/current-user/dealership-switch",
      { dealership: dealershipIri },
      {
        headers: {
          "Content-Type": MIME_TYPE_MERGE_PATCH_JSON,
        },
      },
    )
    .then((response) => response.data);
